module.exports = __webpack_public_path__ + "static/media/facebook-icon.d1e8ff2b.svg";